export const FETCH_REFERRAL_PROGRAMS = 'FETCH_REFERRAL_PROGRAMS';
export const FETCH_REFERRAL_PROGRAMS_LOADING = 'FETCH_REFERRAL_PROGRAMS_LOADING';
export const FETCH_REFERRAL_PROGRAMS_ERROR = 'FETCH_REFERRAL_PROGRAMS_ERROR';

export const FETCH_REFERRAL_PROGRAM_BY_ID = 'FETCH_REFERRAL_PROGRAM_BY_ID';
export const FETCH_REFERRAL_PROGRAM_BY_ID_LOADING = 'FETCH_REFERRAL_PROGRAM_BY_ID_LOADING';
export const FETCH_REFERRAL_PROGRAM_BY_ID_ERROR = 'FETCH_REFERRAL_PROGRAM_BY_ID_ERROR';

export const SET_FILTERS = 'SET_FILTERS';
export const RESET_FILTERS = 'RESET_FILTERS';
export const SET_SORT_PARAMS = 'SET_SORT_PARAMS';
export const SET_PAGINATION = 'SET_PAGINATION';
export const RESET_PAGINATION = 'RESET_PAGINATION';

export const MANDATORY_DATE_FORMAT = 'YYYY-MM-DD';
export const MIN_PEAK_CHECKIN_PERCENTAGE = 0;
export const MAX_PEAK_CHECKIN_PERCENTAGE = 100;
export const MIN_FIRST_DELIVERY_WINDOW_DAYS = 1;
export const MAX_FIRST_DELIVERY_WINDOW_DAYS = 365;

/** Translation key explaining how consecutive milestone windows are chained. */
export const MILESTONE_SEQUENCE_INFO =
  'Milestones are sequential: Milestone 1 starts at onboarding and each following milestone starts when the previous one ends.';
